export type OdometerHistoryOrigin = "TELEMETRIA" | "CHECKLIST" | "MANUAL";

export const VEHICLE_ODOMETER_SOURCE = {
	TELEMETRY: 1,
	CHECKLIST: 2,
	MANUAL: 3,
} as const;

export type VehicleOdometerSourceApi =
	(typeof VEHICLE_ODOMETER_SOURCE)[keyof typeof VEHICLE_ODOMETER_SOURCE];

export const VEHICLE_ODOMETER_ADJUSTMENT_REASON = {
	TELEMETRY_OUTDATED: 1,
	MANUAL_TYPING_ERROR: 2,
	DATA_SOURCE_CHANGED: 3,
	OTHER: 4,
} as const;

export type VehicleOdometerAdjustmentReasonApi =
	(typeof VEHICLE_ODOMETER_ADJUSTMENT_REASON)[keyof typeof VEHICLE_ODOMETER_ADJUSTMENT_REASON];

export type OdometerHistoryItem = {
	id: string;
	updatedAt: string;
	responsible: string;
	previousDisplayValue: string;
	currentDisplayValue: string;
	origin: OdometerHistoryOrigin;
	attachmentName?: string;
	attachmentUrl?: string;
};

export type VehicleOdometerSummaryResponse = {
	vehicleId: number;
	currentOdometer: number | null;
	odometerLastUpdatedAt: string | null;
	isOdometerOutdated: boolean;
	hasTelemetry: boolean;
	lastOdometerSource: VehicleOdometerSourceApi | null;
};

export type VehicleOdometerHistoryItemResponse = {
	vehicleOdometerId: number;
	readingDateTime: string;
	updatedBy: string | null;
	previousOdometer: number | null;
	newOdometer: number;
	source: VehicleOdometerSourceApi;
	hasAttachment: boolean;
};

export type VehicleOdometerHistoryResponse = {
	items: VehicleOdometerHistoryItemResponse[];
	totalCount: number;
	pageSize: number;
	currentPage: number;
	totalPages: number;
};

export type VehicleOdometerLatestChecklistResponse = {
	vehicleId: number;
	checklistAnswerId: number;
	checklistOdometer: number;
	checklistSubmittedAt: string;
};

export type VehicleOdometerCreateResponse = {
	vehicleOdometerId: number;
	vehicleId: number;
	newOdometer: number;
	odometerLastUpdatedAt: string;
};

export type VehicleOdometerDetailResponse = {
	vehicleOdometerId: number;
	vehicleId: number;
	plate: string | null;
	brand: string | null;
	model: string | null;
	readingDateTime: string;
	source: VehicleOdometerSourceApi;
	previousOdometer: number | null;
	newOdometer: number;
	updatedBy: string | null;
	adjustmentReason: VehicleOdometerAdjustmentReasonApi;
	adjustmentReasonDescription: string | null;
	attachmentFileName: string | null;
	attachmentUrl: string | null;
};

export type VehicleOdometerHistoryParams = {
	sources?: VehicleOdometerSourceApi[];
	pageNumber?: number;
	pageSize?: number;
	sortBy?: string;
	sortDirection?: string;
};

export type CreateVehicleOdometerChecklistRequest = {
	checklistAnswerId: number;
	newOdometer: number;
	readingDateTime: string;
};

export type CreateVehicleOdometerManualRequest = {
	newOdometer: number;
	readingDateTime: string;
	adjustmentReason?: VehicleOdometerAdjustmentReasonApi;
	adjustmentReasonDescription?: string;
	attachmentFileKey?: string;
	attachmentFileName?: string;
};

export type VehicleOdometerPresignedUploadRequest = {
	fileName: string;
};

export type VehicleOdometerPresignedUploadResponse = {
	uploadUrl: string;
	fileKey: string;
	fileName: string;
};
